import { takeLatest, put } from 'redux-saga/effects';

import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';
import {
  actionSetGridDataInvalid,
  actionSetGridDataValid,
} from 'react-redux-app/lib/modules/grid/actions';

import { SITE_SEO_GRID_NAME } from '../../constants';

import {
  ACTION_DELETE_SEO_TRANSLATION__REQUEST,
  ACTION_DELETE_SEO_TRANSLATION__SUCCESS,
  ACTION_DELETE_SEO_TRANSLATION__FAIL,

  ACTION_DELETE_SEO_TRANSLATIONS__REQUEST,
  ACTION_DELETE_SEO_TRANSLATIONS__SUCCESS,
  ACTION_DELETE_SEO_TRANSLATIONS__FAIL,

  ACTION_EDIT_SEO_TRANSLATION__REQUEST,
  ACTION_EDIT_SEO_TRANSLATION__SUCCESS,
  ACTION_EDIT_SEO_TRANSLATION__FAIL,
} from '../../actionTypes';


function* enableGrid() {
  try {
    yield put(actionSetGridDataValid(SITE_SEO_GRID_NAME));
  } catch (e) {
    yield put(actionAddException(e));
  }
}

function* disableGrid() {
  try {
    yield put(actionSetGridDataInvalid(SITE_SEO_GRID_NAME));
  } catch (e) {
    yield put(actionAddException(e));
  }
}

export default function* saga() {
  yield takeLatest([
    ACTION_DELETE_SEO_TRANSLATION__REQUEST,
    ACTION_DELETE_SEO_TRANSLATIONS__REQUEST,
    ACTION_EDIT_SEO_TRANSLATION__REQUEST,
  ], disableGrid);

  yield takeLatest([
    ACTION_DELETE_SEO_TRANSLATION__SUCCESS,
    ACTION_DELETE_SEO_TRANSLATION__FAIL,
    ACTION_DELETE_SEO_TRANSLATIONS__SUCCESS,
    ACTION_DELETE_SEO_TRANSLATIONS__FAIL,
    ACTION_EDIT_SEO_TRANSLATION__SUCCESS,
    ACTION_EDIT_SEO_TRANSLATION__FAIL,
  ], enableGrid);
}
